/*
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2023-08-16 08:53:30
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-09-13 15:58:05
 */
import request from "../util/request"

// 获取新闻列表
export function getNewslist (data) {
  return request({
    url: "/api/newsList",
    method: "post",
    data: data,
    params: data,
    headers: {
      deptId: data.deptId ? data.deptId : sessionStorage.getItem('deptId')
    }
  })
}

// 获取新闻列表
export function getNewslist1 (data) {
  return request({
    url: "/api/newsList",
    method: "post",
    params: data,
    data: { keyword: data.keyword }
  })
}

// 新闻分类
export function getNewsClass (data) {
  return request({
    method: "post",
    url: "/api/newsClass",
    data: data,
    params: data,

  })
}

// 获取新闻详情
export function getNewsDetail (data) {
  return request({
    method: "post",
    url: "/api/newsDetail",
    data: data,

  })
}

// 获取字典
export function getDicts (type) {
  return request({
    method: "post",
    url: "/api/typeList",
    data: { dictType: type }
  })
}

// 帮助
export function help () {
  return request({
    method: "post",
    url: "/api/help"
  })
}

// 查询消息通知列表
export function messageList (data) {
  return request({
    method: "get",
    url: "/base/message/list",
    params: data,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  })
}

// 查询消息列表(按分类)
export function msgList (data) {
  return request({
    method: 'post',
    params: data,
    url: '/base/advise/msgList',
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  })
}

// 获取成交公告列表
export function publicityList (data) {
  return request({
    url: "/api/publicityList",
    method: "post",
    data: data,
    params: data,
    headers: {
      deptId: data.deptId ? data.deptId : sessionStorage.getItem('deptId')
    }
  })
}

// 获取鉴证公告列表
export function attest (data) {
  return request({
    url: "/api/attest",
    method: "post",
    data: data,
    params: data
  })
}

// 获取意向转出受让列表
export function desiredList (data) {
  return request({
    url: "/api/desiredList",
    method: "post",
    data: data,
    params: data
  })
}

// 查询消息列表-根据refId
export function msgListByRefId (data) {
  return request({
    method: 'post',
    params: data,
    url: '/base/message/listByRefId',
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  })
}

// 按refId标记消息已读
export function msgReadByRefId (data) {
  return request({
    method: 'post',
    params: data,
    url: '/base/message/readByRefId',
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token")
    }
  })
}

// 获取成交公告详情
export function getPublicityDetail (data) {
  return request({
    method: 'post',
    data: data,
    url: '/api/publicityDetail',
  })
}